import type { QueryKey, useQueryClient } from '@tanstack/vue-query'

/**
 * Update all non-stale queries matching a filter
 */
export function updateNonStaleQueries<TData>(
  queryClient: ReturnType<typeof useQueryClient>,
  queryKey: QueryKey,
  updater: (oldData: TData | undefined) => TData | undefined,
) {
  const allQueries = queryClient.getQueryCache().findAll(queryKey)

  allQueries.forEach((query) => {
    if (!query.isStale()) {
      queryClient.setQueryData<TData>(query.queryKey, updater)
    }
  })
}
